import { IDatabase } from 'core/classes/helpers/store/Interfaces'
import { ICompanies } from 'search/classes/models/ICompanies'
import { ICompanyInfo } from 'search/classes/models/ICompanyInfo'

export enum StoreForms {
  companies = 'companies',
  companyInfo = 'companyInfo',
}

type BaseStructure = {
  companies: ICompanies
  companyInfo: ICompanyInfo
}

export type ISearchState = IDatabase<BaseStructure>

export const initialTmState: ISearchState = {
  forms: {
    companies: {
      data: [] as ICompanies[],
      queries: {},
    },
    companyInfo: {
      data: [] as ICompanyInfo[],
      queries: {},
    },
  },
}
